<ng-container *ngFor="let node of nodes">
    <button
        [ngClass]="(selectedTag | async) && (selectedTag | async).tag === node.data.tag && 'active'"
        [style.padding]="'10px 20px 10px ' + (shift + 20) + 'px'"
        [style.color]="node.data.disabled ? 'darkgray' : null"
        (click)="handleClick(node.data)"
    >
        <emm-icon *ngIf="node.data.scope === 'Location'" symbol="square"></emm-icon>
        <emm-icon *ngIf="node.data.scope !== 'Location' && nodeSelected[node.data.tag]" symbol="down"></emm-icon>
        <emm-icon *ngIf="node.data.scope !== 'Location' && !nodeSelected[node.data.tag]" symbol="right"></emm-icon>
        {{ node.data.name }}
    </button>
    <div
        *ngIf="loading[node.data.tag]"
        [style.padding]="'10px 20px 10px ' + (shift + 40) + 'px'"
    >
        Loading...
    </div>
    <emm-nutrition-assignments-location-sets-list
        *ngIf="childrenNodes[node.data.tag] && childrenNodes[node.data.tag].length"
        [nodes]="childrenNodes[node.data.tag]"
        [shift]="shift + 20"
    ></emm-nutrition-assignments-location-sets-list>
</ng-container>
